<template>
  <div class="map-detail-header">
    <Breadcrumb :links="crumbs" />
    <TabNav :links="tabs" />
  </div>
</template>

<script>
// Cabecera compartida de la sección "detalle de mapa": breadcrumb + las
// pestañas de navegación del mapa. Se incluye en cada sub-vista para que las
// pestañas persistan al navegar entre secciones. La pestaña activa la resalta
// TabNav según la ruta actual.
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'

export default {
  name: 'MapDetailHeader',
  components: { Breadcrumb, TabNav },
  props: ['map'],
  computed: {
    idMap: function() {
      return this.$route.params.idMap;
    },
    mapName: function() {
      return (this.map && this.map.name) ? this.map.name : 'Mapa';
    },
    crumbs: function() {
      return [
        { name: 'Mapas', path: '/mapas' },
        { name: this.mapName }
      ];
    },
    tabs: function() {
      var base = '/mapas/' + this.idMap;
      return [
        { name: 'Resumen', path: base, exact: true },
        { name: 'Ver mapa', path: base + '/visor' },
        { name: 'Usuarios asignados', path: base + '/asignar-usuarios' },
        { name: 'Grupos asignados', path: base + '/asignar-grupos' },
        { name: 'Capas asignadas', path: base + '/asignar-capas' },
        // { name: 'Geoprocesos asignados', path: base + '/asignar-geoprocesos' },
        { name: 'Editar mapa', path: base + '/editar-mapa' },
        { name: 'Historial de cambios', path: base + '/historial-de-cambios' }
      ];
    }
  }
}
</script>
